import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';
import './BarRestaurantTableCard.css';
import AppIcon from './icons/AppIcon';

export default function BarRestaurantTableCard({ table, onOpenTable, isDragging }) {
  const [loading, setLoading] = useState(false);

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  };

  const getTimeAgo = (timestamp) => {
    if (!timestamp) return '';
    const now = new Date();
    const date = new Date(timestamp);
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);

    if (diffMins < 1) return 'Agora';
    if (diffMins < 60) return `Há ${diffMins} min`;
    if (diffHours < 24) return `Há ${diffHours}h`;
    return formatTime(timestamp);
  };

  if (loading) {
    return (
      <div className="bar-restaurant-table-card loading" style={{ opacity: isDragging ? 0.5 : 1 }}>
        <div className="table-loading">
          <AppIcon name="progress_activity" className="spinning" />
        </div>
      </div>
    );
  }

  return (
    <div 
      className="bar-restaurant-table-card" 
      onClick={() => onOpenTable(table)}
      style={{ opacity: isDragging ? 0.5 : 1 }}
    >
      {/* Header com número da mesa */}
      <div className="table-header">
        <div className="table-number">
          <AppIcon name="table_restaurant" />
          <span className="number">Mesa {table.numero_mesa}</span>
        </div>
        <div className="table-total">
          <span className="total-value">R$ {table.total_aberto?.toFixed(2) || '0.00'}</span>
        </div>
      </div>

      {/* Informações da mesa */}
      <div className="table-info">
        <div className="info-item">
          <AppIcon name="shopping_cart" />
          <span className="info-text">{table.pedidos_abertos} pedido{table.pedidos_abertos !== 1 ? 's' : ''}</span>
        </div>
        <div className="info-item">
          <AppIcon name="schedule" />
          <span className="info-text">{getTimeAgo(table.primeira_ordem_em)}</span>
        </div>
      </div>

      {/* Status */}
      <div className="table-footer">
        <div className={`table-status ${table.status === 'fechada' ? 'fechada' : 'aberta'}`}>
          ● {table.status === 'fechada' ? 'Fechada' : 'Aberta'}
        </div>
      </div>
    </div>
  );
}

// Wrapper component que busca dados da mesa a partir do card
export function BarRestaurantTableCardFromCard({ card, onOpenTable, isDragging }) {
  const [tableData, setTableData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (card && card.entity_id) {
      console.log('[BarRestaurantTableCardFromCard] Buscando mesa:', card.entity_id);
      
      supabase
        .from('bar_restaurant_tables')
        .select('id, numero_mesa, status, pedidos_abertos, total_aberto, primeira_ordem_em')
        .eq('id', card.entity_id)
        .single()
        .then(({ data, error: err }) => {
          console.log('[BarRestaurantTableCardFromCard] Resposta:', { data, error: err?.message });
          
          if (err) {
            console.error('[BarRestaurantTableCardFromCard] Erro ao buscar mesa:', err.message);
          } else if (data) {
            console.log('[BarRestaurantTableCardFromCard] Mesa encontrada:', data);
            setTableData(data);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('[BarRestaurantTableCardFromCard] Erro na promise:', err);
          setLoading(false);
        });
    }
  }, [card]);

  if (loading || !tableData) {
    return (
      <div className="bar-restaurant-table-card loading" style={{ opacity: isDragging ? 0.5 : 1 }}>
        <div className="table-loading">
          <AppIcon name="progress_activity" className="spinning" />
        </div>
      </div>
    );
  }

  return <BarRestaurantTableCard table={tableData} onOpenTable={onOpenTable} isDragging={isDragging} />;
}
